import baseCalls from "../.internal/baseCalls.js";
import map from "./map.js";
import object from "./object.js";

export default baseCalls(map, object);